// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//


import { invoicesRangeStyles } from "@eisinc/App/Components/PaymentCenter/InvoicesRange";
import { color } from "@eisinc/XDL/Utilities";
import { CheckboxStyle } from "@insite/mobius/Checkbox";
import { css } from "styled-components";

invoicesRangeStyles.wrapper = {
    css: css`
        width: 100%;
        border: 1px solid ${color("common.ui4")};
        background: ${color("common.ui3")};
        padding: 13px;
        padding-bottom: 0;
    `,
};
invoicesRangeStyles.checkBoxesWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
    `,
};
invoicesRangeStyles.checkboxItemWrapper = {
    css: css`
        margin-bottom: 4px;
        margin-right: 16px;

        ${CheckboxStyle} {
            align-items: flex-start;
        }
    `,
};
invoicesRangeStyles.checkBoxLabelWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        `,
};
invoicesRangeStyles.checkBoxTotal = {
    css: css`
        font-weight: bold;
    `,
};